import React from 'react';
import { Marker } from 'react-map-gl';
import ImgixImg from '@opendoor/bricks/utils/ImgixImg';

import { Box } from '@opendoor/bricks/core';

export interface IProps {
  latitude: number;
  longitude: number;
  onClick?: () => void;
  id?: string;
}

/**
 * TODO: Add documentation
 *
 * component-test-check-ignore
 */
export const HomeMarker: React.FC<IProps> = ({ latitude, longitude, onClick, id }) => {
  if (!longitude || !latitude) {
    return null;
  }

  return (
    <Marker longitude={longitude} latitude={latitude} style={{ pointerEvents: 'none' }}>
      <Box transform="translateY(-20px)" onClick={() => onClick && onClick()} cursor="pointer">
        <ImgixImg
          src="181ea5f1af8e40a994ea3e6c9cb65bcd.svg"
          width={70}
          alt="marker"
          data-propertyid={id}
        />
      </Box>
    </Marker>
  );
};
